import {injectable} from "inversify";
import {Match} from "@/modules/match/entity";
import {Season} from "@/modules/season/entity";
import {Team} from "@/modules/team/entity";
import dayjs from "dayjs";

@injectable()
export default class BeforeMatchMode {
  private enabled = false;

  public enable() {
    this.enabled = true;
  }

  public disable() {
    this.enabled = false;
  }

  public isEnabled() {
    return this.enabled;
  }

  public async isBeforeMatchMode(): Promise<boolean> {
    const season = await Season.current();
    const match = await Match.findNext(season, await Team.current());

    return !!match && season.currentDate.isSame(dayjs.utc(match.matchday.scheduledAt), 'day');
  }
}
